import { render, staticRenderFns } from "./staff-item.vue?vue&type=template&id=6f022955&scoped=true"
import script from "./staff-item.vue?vue&type=script&lang=js"
export * from "./staff-item.vue?vue&type=script&lang=js"
import style0 from "./staff-item.vue?vue&type=style&index=0&id=6f022955&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f022955",
  null
  
)

export default component.exports